import produce from "immer";

import { GET_APP_CFG_PUBLIC_KEY_SUCCESS, GET_APP_CFG_ELOG_QUESTIONS_SUCCESS } from "../actions";

const initialState = {
   publicKey: null,
   eLogQuestions: []
};

const appConfigReducer = produce((draft, action) => {
   // eslint-disable-next-line default-case
   switch (action.type) {
      case GET_APP_CFG_PUBLIC_KEY_SUCCESS:
         draft.publicKey = action.payload.data.key;
         return;
      case GET_APP_CFG_ELOG_QUESTIONS_SUCCESS:
         draft.eLogQuestions = action.payload.data.data;
         return;
   }
}, initialState);

export default appConfigReducer;
